import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import { staticsUrl } from '../../config';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    fontFamily: theme.typography.body1.fontFamily,
  },
  correct: {
    color: theme.palette.error.main,
  },
  incorrect: {
    color: theme.palette.success.main,
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  card: {
    marginBottom: '1em',
  },
  root: {
    display: 'flex',
    cursor: 'pointer',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: '20%',
    paddingBottom: '20%',
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundColor: '#fff',
    margin: '0.5em',
    borderRadius: '0.5em',
    opacity: 0.75,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  collapse: {
    background: 'rgba(255, 255, 255, 0.6)',
  },
  '@media(max-width: 550px)': {
    card: {
      '& h5': {
        fontSize: '1.25em',
      },
      '& h6': {
        fontSize: '1em',
      },
    },
  }
}));

function NewExercise(props) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState([false, false, false ]);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;

  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  const init = () => {
    startStats(type);
    finishExercise();
  }

  const handleClick = idx => {
    action();
    const newExpanded = [ false, false, false ];
    newExpanded[idx] = !expanded[idx];
    setExpanded(newExpanded);
  }

  const colors = ['#cae9fb', '#d9fbca', '#f7cafb', '#fbe9ca', '#cecafb', '#cafbf5'];

  return (
    <div className={classes.wrapper}>
      <div>
        {exercise.length === 0 && <div>
          <h3>Przepraszamy, ale nie mamy dziś żadnych ciekawostek :(</h3>
        </div>}
        {exercise.map((ex, idx) => <Card key={idx} className={classes.card} onClick={() => handleClick(idx)} style={{backgroundColor: colors[idx]}}>
          <div className={classes.root}>
            <CardMedia
              className={classes.cover}
              image={staticsUrl + ex.imageUrl}
              title="Live from space album cover"
            />
            <div className={classes.details}>
              <CardContent className={classes.content}>
                <Typography component="h5" variant="h5">{ex.title}</Typography>
                <Typography variant="subtitle1" color="textSecondary">{ex.translation}</Typography>
              </CardContent>
            </div>
          </div>
          <Collapse in={expanded[idx]} timeout="auto" unmountOnExit className={classes.collapse}>
            <CardContent>
              {ex.textsOne.map(((html, idx) => <div key={idx} dangerouslySetInnerHTML={{ __html: filter(html) }} />))}
              {ex.textsTwo.map(((html, idx) => <div key={idx} dangerouslySetInnerHTML={{ __html: filter(html) }} />))}
            </CardContent>
          </Collapse>
        </Card>)}
        <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>
        </div>
      </div>
    </div>
  );
}

const filter = (html) => {
  let str = html.replace(/font-size/g, "font-size-xxx");
  str = str.replace(/text-align/g, "text-align-xxx");
  str = str.replace(/color/g, "color-xxx");
  str = str.replace(/line-height/g, "line-height-xxx");
  return str.replace(/font-family/g, "font-family-xxx");
}


const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(NewExercise);